module.exports = __webpack_public_path__ + "officialStatic/img/pmj.66a7b10.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/smartCampus/role/pmj.png
// module id = MxXb
// module chunks = 0